import ReactDOM from 'react-dom';
import * as Redux from 'redux';
import thunkMiddleware from 'redux-thunk';
import * as ReactRedux from 'react-redux';

import {SigninOverlayContainer} from "./containers/SigninOverlayContainer.js";
import {actionTypesForSignin} from "./constants/signinOverlayConstants.js";
import {signinReducer} from "./reducers/signinReducers.js";

function prepareReduxStore() {
	const middleware = Redux.applyMiddleware(thunkMiddleware);
	return Redux.createStore(signinReducer, middleware);
}


function signinOverlayMainInit() {
	const data = {};
	const store = prepareReduxStore();
	store.dispatch({
		type: actionTypesForSignin.INIT,
		data: data
	});

	ReactDOM.render(
			(
					<ReactRedux.Provider store={store}>
						<SigninOverlayContainer ref={(signinOverlay) => {window.signinOverlay2Part = signinOverlay }} />
					</ReactRedux.Provider>
			),
			document.getElementById("signin-overlay-main")
	);

};

if (window.generalLoaded) {
	signinOverlayMainInit();
}
else {
	window.addEventListener("generalLoaded", signinOverlayMainInit);
}
